import React from 'react'
import { Container, Row, Col } from 'react-bootstrap'
import 'line-awesome/dist/line-awesome/css/line-awesome.min.css'

const About = () => {
  return (
    <Container className="page-container">
      <h1 className="section-title">About MicroGenie</h1>
      
      <div className="section-icon">
        <i className="la la-info-circle" style={{ fontSize: '40px' }} aria-hidden="true"></i>
      </div>
      
      <Row className="mb-5">
        <Col md={8} className="mx-auto">
          <div className="about-content">
            <p>
              MicroGenie is a web application that provides a collection of microtools designed to help with everyday tasks. 
              Our mission is to simplify common digital tasks by offering easy-to-use, efficient tools all in one place.
            </p>
            <p>
              Whether you need to reduce image sizes, create a professional resume, or find inspiration for your final year project,
              MicroGenie has you covered with our specialized toolkit.
            </p>
          </div>
        </Col>
      </Row>
      
      <h2 className="section-title" style={{fontSize: "2rem"}}>Our Mission</h2>
      <div className="section-icon">
        <i className="la la-bullseye" style={{ fontSize: '40px' }} aria-hidden="true"></i>
      </div>
      
      <Row className="mb-5">
        <Col md={8} className="mx-auto">
          <div className="about-content">
            <p>
              At MicroGenie, we believe that technology should make life easier, not more complicated.
              Our goal is to provide simple yet powerful tools that help students, professionals, and anyone
              who needs to accomplish digital tasks quickly and efficiently.
            </p>
            <p>
              We're particularly focused on helping students at Lahore Garrison University with resources
              specific to their needs, from application forms to FYP project resources.
            </p>
          </div>
        </Col>
      </Row>
      
      <h2 className="section-title" style={{fontSize: "2rem"}}>Our Team</h2>
      <div className="section-icon">
        <i className="la la-users" style={{ fontSize: '40px' }} aria-hidden="true"></i>
      </div>
      
      <Row>
        <Col md={8} className="mx-auto">
          <div className="about-content">
            <p>
              MicroGenie was created by a team of passionate developers who wanted to create something useful
              for their community. We're constantly working to improve our tools and add new features based on user feedback.
            </p>
            <p>
              Have suggestions for new tools? We'd love to hear from you! Contact us at <a href="mailto:contact@microgenie.com" style={{color: "#8a4fff"}}>contact@microgenie.com</a>
            </p>
          </div>
        </Col>
      </Row>
    </Container>
  )
}

export default About
